import React, { Component } from 'react'
import { connect } from 'react-redux'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'
import Waypoint from 'react-waypoint'
import portfolioImage from '../../resources/images/portfolio.webp'
import Image from 'grommet/components/Image'
import { setSectionProperty, setParticleVisibility } from '../../actions/sections/SectionsActions'
import './ReadyToStart.css'

@connect((state) => ({
  isVisible: state.sectionsReducer.readyToStart.isVisible
}), { setSectionProperty, setParticleVisibility })
class ReadyToStart extends Component {

  handleEnter = () => {
    const { setSectionProperty, setParticleVisibility } = this.props
    setSectionProperty('readyToStart', 'isVisible', true)
    setParticleVisibility('home', 'sectionOneParticlesVisible', false)
    setParticleVisibility('home', 'sectionTwoParticlesVisible', true)
  }

  handleLeave = () => {
    const { setSectionProperty } = this.props
    setSectionProperty('readyToStart', 'isVisible', false)
  }

  render() {
    const { isVisible } = this.props
    const className = `ReadyToStart${ isVisible ? ' is-visible' : ''}`
    return (
      <Waypoint bottomOffset="150px" scrollableAncestor={window} onEnter={this.handleEnter} onLeave={this.handleLeave}>
        <div className={className}>
          <Heading tag="h2" uppercase={true} strong={true} className="ReadyToStart-title">Ready to start?</Heading>
          <div className="ReadyToStart-container">
            <div className="ReadyToStart-left">
              <Image src={portfolioImage} />
            </div>
            <div className="ReadyToStart-right">
              <Heading tag="h4" strong={true} size='small'>
                Let's get to work!
              </Heading>
              <Paragraph className="ReadyToStart-paragraph" align="center">
                We are ready to start work on your project whether your business is a SME or large corporation.
                Our portfolio includes web applications tailor built for some of the world's largest fashion brands, financial institutions and independent artists.
                Our main focus is on delivering a luxury end product that will ensure your web application is unparalleled.<br/>
              </Paragraph>
              <br/>
              <Heading className="ReadyToStart-contactUsHeading" tag="h4" strong={true} size="small">
                Contact us today to become part of our exclusive client list.<br />
                <span>Phone: <a className="ReadyToStart-link" href="tel:00353872907349"> +(353) 87 290 7349</a><br /></span>
              </Heading>
            </div>
          </div>
        </div>
      </Waypoint>
    )
  }
}

export default ReadyToStart



// WEBPACK FOOTER //
// ./src/components/ReadyToStart/index.js